import { createFileRoute, Outlet } from '@tanstack/react-router';

import { SiteSectionNav } from '@/features/owner/site/SiteSectionNav';

/** Раздел «Site» (лендинг-CMS): под-навигация + активный подраздел. Подразделы
 *  (content/courses/subjects/testimonials) вкладываются как дочерние роуты. */
function SiteLayout() {
  return (
    <div className="space-y-6">
      <SiteSectionNav />
      <Outlet />
    </div>
  );
}

export const Route = createFileRoute('/_authed/owner/site')({
  component: SiteLayout,
});
